module.exports = __webpack_public_path__ + "static/media/skiing-nordic.3175fb61.svg";